import React from 'react'
import NavLink from '../Routes/NavLink'

export default class BuildingTemplateCard extends React.Component {
    constructor(props) {
        super(props);
        
        this.totalSpaces = 0;
    }

    componentDidMount() {
    }

    componentWillUpdate(nextProps, nextState) {
        // reset total
        this.totalSpaces = 0;
    }

    calcTotalSpaces(specs, index) {
        var total = 0;
        var spec = specs[index];
        var values = Object.values(spec)
        values.forEach(function(amount) {
            total += parseInt(amount);
        }, this);

        return total;
    }

    calcTotalSpacesWithoutReturn(specs) {
        var total = 0;
        specs.forEach(function(spec, index) {
            var values = Object.values(spec)
            values.forEach(function(amount) {
                total += parseInt(amount);
            }, this);
        }, this);
        this.totalSpaces = total;
        return total;
    }

    formatSpecs(specs, index) {
        var formatted = new Array();
        var spec = specs[index];
        var values = Object.values(spec)
        var keys = Object.keys(spec)
        keys.forEach(function(key, index) {
            var html = '' + values[index] + ' :' + key;
            formatted.push(html);
        }, this);

        return formatted;
    }
    render(){
        // localize instance
        var self = this;
        const templateData = this.props.specs;
        const templateName = this.props.name;
        const levelLimit = this.props.levelLimit;
        const activeTemplateID = this.props.activeTemplateID;
        var active = '';
        if(activeTemplateID == this.props.templateID) {
            active = 'selected';
        }
        // we need to figure total before moving forward
        if(templateData !== undefined) {
            self.calcTotalSpacesWithoutReturn(templateData);
        }
        return (
            <div class={"col-md-4 building-template-card " + active} key={self.props.templateID} onClick={this.props.activateTemplate.bind(self,self.props.templateID, self.totalSpaces)}>
                <div class="card">
                    <div class="header">
                        <h4 class="title">{templateName}</h4>
                    </div>
                    <div class="content">
                         {templateData != null && templateData.length > 0 ? (
                            templateData.map(function(data, index){
                                const formattedSpecList = self.formatSpecs(templateData, index);
                                const totalSpaces = self.calcTotalSpaces(templateData, index);
                                return (
                                    <div key={index}>
                                        <span class="specific-space-detail">
                                            Level {index+1}: <i class="fa fa-cube"></i> - {totalSpaces} Spaces
                                        </span>
                                        {formattedSpecList.map(function(html, index){
                                            return (
                                                <p key={index}>{html}</p>
                                            )
                                        })}
                                    </div>
                                )
                            })
                        ) : (
                            <p>Blank Template</p>
                            )
                        }
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Building/BuildingTemplateCard.jsx